import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LifeGridHome from './LifeGridHome';
import AgencyPage, { resolveAgency } from './AgencyPage';

// If the site is being viewed on one of the outreach/agency domains
// (e.g. alphacloseco.com), serve that agency's standalone landing page.
// On habitat.inc it serves the Habitat homepage.
const agency = resolveAgency();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {agency ? <AgencyPage agency={agency} /> : <LifeGridHome />}
  </React.StrictMode>
);
